import React from 'react';
import { useLocation } from 'react-router-dom';
import { AlertBubbleIcon } from '@shopify/polaris-icons';
import { Navigation } from '@shopify/polaris';

import { AuthenticationContext } from '../../homeModules/auth/contexts/AuthenticationContext';

const EnergySolutionsSidebar: React.FC = () => {
  const location = useLocation();
  const { user } = React.useContext(AuthenticationContext);

  const isAdminUser = user?.modules?.some(
    (module) => module.value === 'energy_solutions' && parseInt(module.tier) >= 2,
  );

  const hasAdminAccess = isAdminUser;
  const navigationItems = [];

  if (hasAdminAccess) {
    navigationItems.push({
      label: 'Energy Solutions',
      url: '/energy_solutions/customer_lookup',
      icon: AlertBubbleIcon,
      matches: true,
      subNavigationItems: [
        {
          url: '/energy_solutions/customer_lookup',
          disabled: false,
          label: 'Customer Lookup',
        },
        {
          url: '/energy_solutions/new_customer',
          disabled: false,
          label: 'New Customer',
        },
        {
          url: '/energy_solutions/recent_submissions',
          disabled: false,
          label: 'Previous Submissions',
        },
      ],
    });
  }

  return (
    <Navigation location={location.pathname}>
      <Navigation.Section items={navigationItems} />
    </Navigation>
  );
};

export default EnergySolutionsSidebar;
